document.addEventListener('DOMContentLoaded', () => {
  let currentSlideIndex = 0;
  const track = document.querySelector('.testimonials-track');
  const slides = Array.from(track.children);
  const nextButton = document.querySelector('.testimonial-nav.next');
  const prevButton = document.querySelector('.testimonial-nav.prev');

  // Set the width of the track to be the total width of all slides
  const setTrackWidth = () => {
    const totalWidth = slides.length * 100; // 100vw for each slide
    track.style.width = `${totalWidth}vw`;
  };

  // Call this function to set the width on load and on window resize
  setTrackWidth();
  window.addEventListener('resize', setTrackWidth);

  // Function to move to slide
  const moveToSlide = (newIndex) => {
    const newLeft = newIndex * -100; // Each slide is 100vw
    track.style.transform = `translateX(${newLeft}vw)`;
    currentSlideIndex = newIndex; // Update the current slide index
  };

  // Click handlers for navigation buttons
  prevButton.addEventListener('click', () => {
    if (currentSlideIndex > 0) {
      moveToSlide(currentSlideIndex - 1);
    } else {
      moveToSlide(slides.length - 1); // Go to the last slide if we're at the first
    }
  });

  nextButton.addEventListener('click', () => {
    if (currentSlideIndex < slides.length - 1) {
      moveToSlide(currentSlideIndex + 1);
    } else {
      moveToSlide(0); // Go to the first slide if we're at the last
    }
  });

  // Initialize the slider
  moveToSlide(0); // Start at the first slide
});



// Add a function to trigger the image animation
const triggerImageAnimation = () => {
  slides.forEach(slide => {
    const img = slide.querySelector('.testimonial-image img');
    img.classList.remove('animate-image'); // Reset the animation
    void img.offsetWidth; // Trigger reflow to reset animation
    img.classList.add('animate-image'); // Add the class to start the animation
  });
};

// Modify moveToSlide to use the new function
const moveToSlide = (newIndex) => {
  // ... Existing code ...
  triggerImageAnimation(); // Trigger the image animation
};



